export default {
  'component.menu.editprofile': 'Rediger Profil',
  'component.menu.changepassword': 'Bytt Passord',
  'component.menu.logout': 'Logg ut',
};
